export const FONT_THIN = 'SpartanThin';
export const FONT_LIGHT = 'SpartanLight';
export const FONT_EXTRA_LIGHT = 'SpartanExtraLight';
export const FONT_REGULAR = 'SpartanRegular';
export const FONT_MEDIUM = 'SpartanMedium';
export const FONT_SEMI_BOLD = 'SpartanSemiBold';
export const FONT_BOLD = 'SpartanBold';
export const FONT_EXTRA_BOLD = 'SpartanExtraBold';
export const FONT_BLACK = 'SpartanBlack';
